webpackJsonp([263791100135453],{

/***/ 239:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(138);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var linkStyle = {
	  color: '#4c8cee',
	  textDecoration: 'none'
	};
	
	var AboutPage = function AboutPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'h2',
	      null,
	      'About'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I\'ve been going to Major League Baseball games since I was young, and fascinated with the idea of seeing a game at every park not too long after that. My quest started in earnest during college in California, and has continued as I\'ve lived in Atlanta and New York City. I\'m now a software developer at MLB Advanced Media, so my work has only fueled the adventure.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Unlike football or baseball, there are no set dimensions for a Major League Baseball stadium. To me, that means each feels distinct, with their own unique features--think Tal\'s Hill in Houston (RIP) or McCovey Cove in San Francisco. Add in regional foods and beers, mascot races, plus any other number of city-specific aspects of a ballpark, and each game feels like a shortcut to getting to know a city. With only 30 teams, visiting each ballpark feels like an ambitious yet attainable goal. My progress is available on the',
	      ' ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { style: linkStyle, to: '/stats/' },
	        'stats page'
	      ),
	      '. /* Each of my visits can be seen on the',
	      ' ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { style: linkStyle, to: '/visits/' },
	        'visits page'
	      ),
	      '.*/'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Site'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This project was inspired by a talk I saw',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: 'http://jlord.us', target: '_blank', style: linkStyle },
	        'Jessica Lord'
	      ),
	      ' ',
	      'give at BrooklynJS in July 2017. Specifically, she spoke about using spreadsheets as a database for websites. The idea really clicked with me - spreadsheets have low setup out of the box, are easy to change, and are intuitive for non-developers to use. She demoed her site',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        {
	          href: 'http://jlord.us/vermeer/index.html',
	          target: '_blank',
	          style: linkStyle
	        },
	        'Vermeer Goals'
	      ),
	      '; her Vermeer quest reminded me of my ballpark hunt, and the lightbulb went off to try and build my own. Consider this site a spiritual fork of hers.',
	      ' '
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Apart from a spreadsheet backend, this project also explores two other technologies I had wanted to play around with: static site generation (using Gatsby), and React. This site is open source, and viewable',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: '', style: linkStyle },
	        'here'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Data'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This site is powered by a \'backend\' that lives in Google Sheets, and is converted to JSON via Tabletop. The data lives',
	      ' ',
	      _react2.default.createElement(
	        'a',
	        { href: '', style: linkStyle },
	        'here'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Me'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'I\'m Colin MacKenzie, a software developer for MLB Advanced Media.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'b',
	        null,
	        'Personal site\u2014'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'http://colinwmackenzie.com', target: '_blank', style: linkStyle },
	        'colinwmackenzie.com'
	      )
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      _react2.default.createElement(
	        'b',
	        null,
	        'Twitter\u2014'
	      ),
	      _react2.default.createElement(
	        'a',
	        { href: 'https://twitter.com/mackenco', target: '_blank', style: linkStyle },
	        '@mackenco'
	      )
	    )
	  );
	};
	
	exports.default = AboutPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-00264a0fe43fbec81f91.js